import { ExtraInformationType } from '@hb/domain/extra-information-type';
import { StartersDispensationInfoPipe } from '@hb/modules/applicants/transformer/starters-dispensation-info-pipe/starters-dispensation-info.pipe';
import { ExtraInformationComponent } from '@hb/modules/global/tip/extra-information.component';
import { NextButtonComponent } from '@hb/modules';
import { ApplicantsStoreService } from '@hb/modules/applicants/applicants-store.service';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';

import { StartersDispensation } from '@ap/ap-interface-apix-hypotheken-berekening';
import { ApContentModule } from '@ap/content';

@Component({
    selector: 'starters-dispensation-info',
    templateUrl: './starters-dispensation-info.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        ReactiveFormsModule,
        AsyncPipe,
        StartersDispensationInfoPipe,
        StartersDispensationInfoPipe,
        ExtraInformationComponent,
        NextButtonComponent
    ]
})
export class StartersDispensationInfoComponent implements OnInit {
    protected readonly store = inject(ApplicantsStoreService);

    protected readonly textType = ExtraInformationType;
    protected readonly options = StartersDispensation;

    option: StartersDispensation;

    ngOnInit(): void {
        this.store.getStartersDispensation().subscribe((option) => {
            this.option = option;
        });
    }

    nextQuestion(): void {
        this.store.setStartersDispensationInfoFinished();
    }
}
